import React from 'react';
import { useDispatch } from 'react-redux';
import { setFiltroUsuarios } from "../../actions/usuariosActions";
import "react-toastify/dist/ReactToastify.css";

export default function FiltroUsuarios({ filtro, fetchUsuarios, actualizarNombreBusqueda, handleReset }) {
  const dispatch = useDispatch();
  const { nombreUsuario } = filtro;

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedParams = { ...filtro, [name]: value };

    dispatch(setFiltroUsuarios(updatedParams));
    actualizarNombreBusqueda(value);
  };

  return (
    <form className="card card-body filter-card form-material" onSubmit={(e) => {
      e.preventDefault();
      dispatch(setFiltroUsuarios({ ...filtro, numeroPagina: 1 })).then(() => fetchUsuarios());
    }}>
      <div className="row align-items-end">
        <div className="col-12 col-sm-3 col-md-2">
          <label className="label-oscura">Nombre Usuario</label>
          <input
            type="text"
            name="nombreUsuario"
            className="form-control"
            value={nombreUsuario || ""}
            onChange={handleChange}
            maxLength="30"
            onInput={(e) => e.target.setCustomValidity("")}
            autoComplete="off"
          />
        </div>
        <div className="col-12 col-sm-3 col-md-2">
          <label className="label-oscura">Estado</label>
          <select
            name="activo"
            className="form-control"
            value={filtro.activo !== undefined ? filtro.activo : ""}
            onChange={(e) => {
              const val = e.target.value;
              // Mapear selección "activo" a booleano o undefined
              const activoValue = val === "true" ? true : (val === "false" ? false : undefined);
              const updatedParams = { ...filtro, activo: activoValue };
              dispatch(setFiltroUsuarios(updatedParams));
            }}
          >
            <option value="">Todos</option>
            <option value="true">Activos</option>
            <option value="false">Inactivos</option>
          </select>
        </div>

        <div className="col-12 col-sm-6 text-center text-sm-end mt-sm-3">
          <button type="submit" className="btn btn-sm btn-grey mt-2 mt-sm-0">Buscar</button>
          <button
            type="button"
            className="btn btn-sm btn-grey ms-2 ms-sm-2 mt-2 mt-sm-0"
            onClick={handleReset}
          >
            Limpiar
          </button>
        </div>
      </div>
    </form>
  );
}